import React from 'react';
import { AccessComponentEnum, AccessLevelEnum } from 'graphql-common';
import { APP_URLS } from 'constants/urls';
import { NavItem, NavItemTypeEnum } from '@lib/components/Menu/Menu';
import Icons from '@lib/components/Icons/Icons';
import Chip, { ChipSizes, ChipTypes } from '@lib/components/Chip/Chip';
import { NavItemArgs } from './types';

export default function getInterventionsNavItem(args: NavItemArgs) {
  const {
    id = '',
    pathname,
    t,
    urlParams,
    getUserAccessByComponent,
    getUserAccessByCompany,
  } = args;
  const isInterventionsAvailable =
    getUserAccessByComponent(AccessComponentEnum.InterventionsManagement) !==
    AccessLevelEnum.LimitedRead;
  const isInterventionsLocked =
    getUserAccessByCompany(AccessComponentEnum.InterventionsManagement) ===
    AccessLevelEnum.LimitedRead;
  const isInterventionCategoriesAvailable =
    getUserAccessByComponent(
      AccessComponentEnum.InterventionCategoriesManagement,
    ) !== AccessLevelEnum.LimitedRead;
  const children: NavItem<unknown>[] = [];
  let to = APP_URLS.dashboard.interventions.index.getPathWithQuery();
  if (isInterventionsAvailable) {
    children.push({
      id: 'all-interventions',
      title: t('all-interventions'),
      to: APP_URLS.dashboard.interventions.index.getPathWithQuery(),
      type: NavItemTypeEnum.PrimarySub,
      end: true,
      predictorFnActive: () => {
        return (
          APP_URLS.dashboard.interventions.add.isTheSameUrlAs(pathname) ||
          APP_URLS.dashboard.interventions.edit.isTheSameUrlAs(pathname, {
            pathParts: { id },
          }) ||
          APP_URLS.dashboard.interventions.view.isTheSameUrlAs(pathname, {
            pathParts: { id },
          }) ||
          APP_URLS.dashboard.interventions.viewActions.isTheSameUrlAs(
            pathname,
            {
              pathParts: { id },
            },
          ) ||
          APP_URLS.dashboard.interventions.actionAdd.isTheSameUrlAs(pathname, {
            pathParts: { id },
          }) ||
          APP_URLS.dashboard.interventions.actionEdit.isTheSameUrlAs(pathname, {
            pathParts: { id, actionId: urlParams?.actionId },
          })
        );
      },
    });
  }
  if (isInterventionCategoriesAvailable) {
    children.push({
      id: 'intervention-categories',
      title: t('categories'),
      to: APP_URLS.dashboard.interventions.categories.getPathWithQuery(),
      type: NavItemTypeEnum.PrimarySub,
      end: true,
      predictorFnVisible: () => isInterventionCategoriesAvailable,
    });
    if (!isInterventionsAvailable) {
      to = APP_URLS.dashboard.interventions.categories.getPathWithQuery();
    }
  }
  return {
    id: 'interventions',
    title: t('interventions'),
    leftIcon: Icons.interventions,
    rightIcon: isInterventionsLocked
      ? (isCollapsed: boolean) => (
          <Chip
            leftIcon="lock"
            size={isCollapsed ? ChipSizes.extraSmall : ChipSizes.small}
            type={ChipTypes.chipBlue}
          />
        )
      : undefined,
    to,
    type: NavItemTypeEnum.Primary,
    predictorFnVisible: () =>
      isInterventionsAvailable ||
      isInterventionsLocked ||
      isInterventionCategoriesAvailable,
    predictorFnActive: () => {
      return (
        APP_URLS.dashboard.interventions.index.isTheSameUrlAs(pathname) ||
        APP_URLS.dashboard.interventions.categories.isTheSameUrlAs(pathname) ||
        APP_URLS.dashboard.interventions.add.isTheSameUrlAs(pathname) ||
        APP_URLS.dashboard.interventions.edit.isTheSameUrlAs(pathname, {
          pathParts: { id },
        }) ||
        APP_URLS.dashboard.interventions.view.isTheSameUrlAs(pathname, {
          pathParts: { id },
        }) ||
        APP_URLS.dashboard.interventions.viewActions.isTheSameUrlAs(pathname, {
          pathParts: { id },
        })
      );
    },
    children,
  };
}
